import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TaskItemStatus } from '@r1-development/resolution-mechanicalturk-api-client';
import { SidebarTaskGroupUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';

@Component({
  selector: 'ri-resolution-ui-mail-package-group-template',
  templateUrl: './mail-package-group-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailPackageGroupTemplateComponent {
  readonly group = input.required<SidebarTaskGroupUi>();
  readonly taskItemStatus = TaskItemStatus;
}
